import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/_atoms/select";
import { GHG_QUALITY_OPTIONS, GhgQuality, isGhgQuality } from "@ark/shared";

interface Props {
  value: GhgQuality | null;
  onValueChange: (value: GhgQuality) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

export function GhgQualitySelect({ value, onValueChange, disabled, ariaLabel }: Props): ReactElement {
  const { t } = useTranslation("inventory");
  return <Select value={value ?? ""} disabled={disabled} onValueChange={(next) => { if (isGhgQuality(next)) onValueChange(next); }}>
    <SelectTrigger className="mt-1 h-8 flex-1 text-xs" aria-label={ariaLabel ?? t("rightAside.dataQuality")}>
      <SelectValue placeholder={t("gpcEmissionFactorRightAside.selectQuality")} />
    </SelectTrigger>
    <SelectContent>{GHG_QUALITY_OPTIONS.map((option) => <SelectItem key={option} value={option}>
      {t(`gpcEmissionFactorRightAside.quality.${option}`)}
    </SelectItem>)}</SelectContent>
  </Select>;
}
